import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BatchOperation\PreviewBatchOperationController::__invoke
* @see app/Http/Controllers/BatchOperation/PreviewBatchOperationController.php
* @route '/api/batch-operations/preview'
*/
const PreviewBatchOperationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: PreviewBatchOperationController.url(options),
    method: 'post',
})

PreviewBatchOperationController.definition = {
    methods: ["post"],
    url: '/api/batch-operations/preview',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BatchOperation\PreviewBatchOperationController::__invoke
* @see app/Http/Controllers/BatchOperation/PreviewBatchOperationController.php
* @route '/api/batch-operations/preview'
*/
PreviewBatchOperationController.url = (options?: RouteQueryOptions) => {
    return PreviewBatchOperationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BatchOperation\PreviewBatchOperationController::__invoke
* @see app/Http/Controllers/BatchOperation/PreviewBatchOperationController.php
* @route '/api/batch-operations/preview'
*/
PreviewBatchOperationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: PreviewBatchOperationController.url(options),
    method: 'post',
})

export default PreviewBatchOperationController